import { jsx as _jsx } from "react/jsx-runtime";
import { CTAWrapper } from "./CTA";
import { CustomContentContainer } from "./Containers/CustomContentContainer";
import { InfoCardWrapper } from "./InfoCards/InfoCardWrapper";
import { MediaWrapper } from "./media/MediaWrapper";
import { getContentBlockStyling } from "../functions";
import { Paragraph } from "./Paragraph";
const COMPONENT_MAPPING = {
    ctaButton: CTAWrapper,
    infoCard: InfoCardWrapper,
    customContentSection: CustomContentContainer,
    paragraph: Paragraph,
    media: MediaWrapper,
};
const formatFieldsToProps = (fields, contentBlockStyles, componentId) => {
    switch (componentId) {
        case "ctaButton":
            return {
                cta: fields,
            };
        case "infoCard":
            return {
                infoCardSchema: fields,
            };
        case "paragraph": {
            return {
                paragraph: fields.paragraph,
                fontSize: fields.fontSize,
                sectionStyles: contentBlockStyles,
            };
        }
        case "media": {
            return {
                media: fields.media,
                title: fields.title,
                sectionStyles: contentBlockStyles,
            };
        }
        case "customContentSection":
            const { sectionStyles } = fields;
            return Object.assign(Object.assign({}, fields), { formattedSectionStyles: sectionStyles ? getContentBlockStyling(sectionStyles) : contentBlockStyles });
        default:
            return fields;
    }
};
const extractComponentsFromContent = (content, contentBlockStyles) => (content !== null && content !== void 0 ? content : []).flatMap((item) => {
    var _a, _b;
    const { fields, sys } = item;
    const componentId = (_b = (_a = sys === null || sys === void 0 ? void 0 : sys.contentType) === null || _a === void 0 ? void 0 : _a.sys) === null || _b === void 0 ? void 0 : _b.id;
    if (!componentId) {
        console.warn("Component ID is missing. Skipping rendering.");
        return [];
    }
    return {
        id: sys.id,
        componentId,
        fields: formatFieldsToProps(fields, contentBlockStyles, componentId),
    };
});
export const ComponentRegistry = ({ content, contentBlockStyles, pageSectionId, isStatic = false, }) => {
    if (!content || !Array.isArray(content)) {
        console.warn("Content is missing or not an array. Nothing to render.");
        return null;
    }
    const extractedComponents = extractComponentsFromContent(content, contentBlockStyles);
    return extractedComponents.map((componentData) => {
        const { componentId, fields } = componentData;
        const Component = COMPONENT_MAPPING[componentId];
        if (!Component) {
            console.warn(`Component with ID ${componentId} not found for item ${componentData.id}. Skipping rendering.`);
            return null;
        }
        return (_jsx(Component, Object.assign({}, fields, { isStatic: isStatic, id: componentData.id, pageSectionId: pageSectionId }), componentData.id));
    });
};
